<template>
	<TemplateBase :is-sales="isSales">
		<div class="w-full pb-[5vh] -pt-[10vw]">
			<div
				class="absolute w-screen overflow-hidden -skew-y-6 h-screen md:h-[90vh] -mt-[12vh] max-h-[160vw] md:max-h-[80vw] lg:max-h-none"
			>
				<div class="skew-y-6 pt-[12vh] flex justify-center">
					<AtomVideo
						v-if="backgroundVideo"
						v-bind="backgroundVideo"
						class="object-cover w-full h-screen md:h-[90vh] max-h-[160vw] md:max-h-[80vw] lg:max-h-none"
						:class="{
							grayscale: !!videoColor,
						}"
						autoplay
						loop
						muted
						preload="auto"
						plays-inline
					/>
					<div
						class="absolute top-0 right-0 bottom-0 left-0"
						:class="{
							'from-brand-900/75 to-brand-900/0 bg-gradient-to-r mix-blend-multiply': !videoColor,
							'from-red-200 to-purple-500 bg-gradient-to-br mix-blend-hard-light': videoColor === VideoColorEnum.RedPurple,
						}"
					/>
				</div>
			</div>
			<div
				class="container flex flex-col gap-8 z-10 justify-end items-center h-[30rem] lg:h-[40rem]"
			>
				<slot name="head" />
				<LazyAtomBreadcrumbs
					v-if="breadcrumbs"
					:breadcrumbs="breadcrumbs"
					class="text-functional-size-sm z-10"
				/>
			</div>
		</div>
		<slot />
	</TemplateBase>
</template>

<script lang="ts" setup>
import { VideoColorEnum } from '#base/core/enums/VideoColorEnum';
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import type { VideoType } from '#base/core/types/VideoType';

defineProps<{
	backgroundVideo?: VideoType;
	pageTitle: string;
	pageTitlePrefix?: string;
	pageTitleSuffix?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
	videoColor?: VideoColorEnum;
}>();
</script>
